var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstKeyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 12V23.7333C25.3334 25.2268 25.3334 25.9735 25.0428 26.544C24.7871 27.0457 24.3792 27.4537 23.8774 27.7094C23.307 28 22.5602 28 21.0667 28H10.9334C9.43994 28 8.6932 28 8.12277 27.7094C7.62101 27.4537 7.21306 27.0457 6.9574 26.544C6.66675 25.9735 6.66675 25.2268 6.66675 23.7333V8.26667C6.66675 6.77319 6.66675 6.02646 6.9574 5.45603C7.21306 4.95426 7.62101 4.54631 8.12277 4.29065C8.6932 4 9.43994 4 10.9334 4H17.3334M25.3334 12L17.3334 4M25.3334 12H21.6001C20.1066 12 19.3599 12 18.7894 11.7094C18.2877 11.4537 17.8797 11.0457 17.6241 10.544C17.3334 9.97354 17.3334 9.22681 17.3334 7.73333V4M10.6667 8H13.3334M10.6667 12H13.3334M21.3334 22.6667H18.6667L17.3334 20.6667L16.0001 22.6667L13.3334 18.6667L12.6667 22.6667H10.6667",
    stroke: "#D6D8E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstKeyIcon);
export default __webpack_public_path__ + "static/media/firstKeyIcon.074ddc7a2a32fe60c8e99438c0ba3dfa.svg";
export { ForwardRef as ReactComponent };